import './style.scss'
import { useMyCampsQuery, useCampLazyQuery, useParticipantsLazyQuery, useSpecialTalentsLazyQuery } from '../../lib/apollo/types'
import CampCard from './CampCard'
import Slider from '../Slider'
import { format } from 'date-fns'
import Divider from '../Divider'
import { useEffect } from 'react'

let today = new Date()
const firstJuly = new Date(2023, 6, 1)
if (today < firstJuly) {
  today = firstJuly
}
const dateInTwoWeeks = new Date(+today)
dateInTwoWeeks.setDate(today.getDate() + 90)

const Camps: React.FC = () => {
  const { data } = useMyCampsQuery({
    variables: {
      start: format(today, 'yyyy-MM-dd'),
      end: format(dateInTwoWeeks, 'yyyy-MM-dd')
    },
    fetchPolicy: 'cache-and-network'
  })

  // Lazy queries for pre-caching camp details
  const [loadCampDetails] = useCampLazyQuery()
  const [loadParticipants] = useParticipantsLazyQuery()
  const [loadSpecialTalents] = useSpecialTalentsLazyQuery()

  // Pre-cache details for user's camps (highest priority)
  useEffect(() => {
    if (data?.myCamps && navigator.onLine) {
      // Pre-cache all of user's camps since they're most likely to access them
      setTimeout(() => {
        data.myCamps.forEach((camp) => {
          console.log(`Pre-caching details for my camp: ${camp.caption}`)

          // Pre-cache camp details
          loadCampDetails({
            variables: { campId: camp.id },
            fetchPolicy: 'cache-and-network'
          })

          // Pre-cache participants
          loadParticipants({
            variables: { campId: camp.id },
            fetchPolicy: 'cache-and-network'
          })

          // Pre-cache special talents
          loadSpecialTalents({
            variables: { campId: camp.id },
            fetchPolicy: 'cache-and-network'
          })
        })
      }, 1000) // Wait 1 second (higher priority than AllCamps)
    }
  }, [data?.myCamps, loadCampDetails, loadParticipants, loadSpecialTalents])

  if (!data?.myCamps || data.myCamps.length === 0) {
    return null
  }

  return (
        <>
            <Slider
                title={'Meine Camps'}
                itemWidth={240}
                freeMode={true}
            >
                {data?.myCamps?.map(camp => (
                    <CampCard key={camp.id} camp={camp} />
                ))}
            </Slider>
            <Divider />
        </>
  )
}

export default Camps
